import styled from "styled-components"

import { minWidth, when } from "utils"

import CloudinaryImage from "components/cloudinary-image"

export const Wrapper = styled.div`
  padding: 3rem 0;
  border-bottom: 0.3rem solid #f3f3f3;

  &:first-of-type {
    border-top: 0.3rem solid #f3f3f3;
  }
`

export const TopContainer = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;

  ${minWidth.tablet`
    margin-bottom: 4rem;
    flex-direction: row;
    justify-content: space-between;
  `}
`

export const Left = styled.div`
  width: 100%;

  ${minWidth.tablet`
    width: calc(100% - 29.2rem - 5.5rem);
  `}
`

export const Title = styled.h3`
  font-size: 2rem;
  font-weight: 500;
  line-height: 1.35;
  letter-spacing: 0.02em;

  ${minWidth.tablet`
    font-size: 2.8rem;
    line-height: 1.35;
  `}
`

export const Image = styled(CloudinaryImage)`
  position: unset;
  height: unset;
  margin: 1rem auto;
  overflow: unset;

  picture {
    img {
      position: unset;
      top: unset;
      left: unset;
      width: 100%;
      max-height: 36.6rem;
      object-fit: contain;
    }
  }
`
export const ButtonContainer = styled.div`
  ${when("isActive")`
    display: flex;
    flex-direction: column;
    border: 1px dashed #c14e78;
    padding: 0.7rem 1rem 1rem 1rem;
    margin: 0 -1rem;
  `}
  &:not(:last-child) {
    margin-bottom: 1.3rem;
  }
`
export const TextAndCodeContainer = styled.div`
  display: none;
  ${when("isActive")`
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 1rem;
    font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1px;
    color: #c14e78;
  `}
`
export const DiscountAndIconContainer = styled.div`
  display: flex;
  align-items: center;
  width: 35%;
  justify-content: space-around;
  padding: 0.4rem;
  border-radius: 0.3rem;
  border: 1px solid #c14e78;
`
export const ViewButton = styled.a`
  width: 100%;
  padding: 1.5rem 3rem;
  border: 0.1rem solid #222;
  border-radius: 5rem;
  display: block;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.67;
  letter-spacing: 0.112rem;
  text-align: center;
  text-transform: uppercase;
  background-color: #fff;
  color: #222;

  &:not(:last-of-type) {
    margin-bottom: 1.3rem;
  }

  ${minWidth.tablet`
    font-size: 1.4rem;
    line-height: 1.43;
  `}
`

export const Right = styled.div`
  height: fit-content;
  margin-top: 3rem;
  padding: 2rem 3.2rem;
  background-color: #efeee9;

  &:empty {
    display: none;
  }

  ${minWidth.tablet`
    width: 29.2rem;
    margin-top: 0;
    margin-left: 5.5rem;
  `}
`

export const ListWrapper = styled.div`
  margin-bottom: 2.25rem;
`

export const ListTitle = styled.h4`
  margin-bottom: 1.4rem;
  padding-bottom: 0.6rem;
  border-bottom: 0.1rem solid #222;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.3rem;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.04rem;
`

export const ListItems = styled.ul`
  margin: 0;
  padding-left: 1.8rem;
  font-size: 1.6rem;
  line-height: 1.56;
  letter-spacing: 0.04rem;
  list-style: none;

  ${minWidth.tablet`
    font-size: 1.8rem;
    line-height: 1.35;
  `}
`

export const ListItem = styled.li`
  &:not(:last-of-type) {
    margin-bottom: 1rem;
  }

  &:before {
    content: "•";
    width: 1em;
    margin-left: -1.6rem;
    display: inline-block;
    font-weight: bold;
  }
`

export const SelectedCategoriesWrapper = styled.div`
  font-size: 1.6rem;
  line-height: 1.35;
  letter-spacing: 0.04rem;

  ${minWidth.tablet`
    font-size: 1.8rem;
    line-height: 1.44;
  `}

  ${when("first")`
    padding-top: 2rem;
  `}

  &:not(:last-of-type) {
    margin-bottom: 1rem;
  }
`

export const SelectedCategoriesTitle = styled.h4`
  display: inline;
  font-size: 1.8rem;
  line-height: 1.44;
  font-weight: 500;
`

export const SelectedCategoriesText = styled.span`
  &:not(:last-of-type):after {
    content: ", ";
  }
`

export const Description = styled.div`
  font-size: 1.8rem;
  line-height: 1.33;
  letter-spacing: 0.04rem;

  a {
    font-weight: 500;
    color: #b5471f;
  }
`
export const ReadMoreButton = styled.button`
  font-size: 1.6rem;
  text-decoration: underline;
  font-weight: 500;
`
